import { css } from 'linaria';
import { resetOnboarding } from 'connectors/onboarding/onboarding.state';
import { useDispatch, useSelector } from 'react-redux';
const resetStyles = "ru8lzzc";
export const Resets = () => {
  const dispatch = useDispatch();
  const {
    user_id
  } = useSelector(state => state.user);

  const onboardingReset = () => dispatch(resetOnboarding());

  const wipeBrazeData = () => {
    import('common/utilities/braze/braze-lazy-load').then(({
      wipeData,
      changeUser
    }) => {
      wipeData(), changeUser(user_id);
    });
  };

  return <div className={resetStyles}>
      <h6>Account Resets</h6>
      <div className="resetter" onClick={onboardingReset}>
        <div className="title">Reset Onboarding</div>
        <div className="description">Start onboarding from the start</div>
      </div>
      <div className="resetter" onClick={wipeBrazeData}>
        <div className="title">Reset Braze</div>
        <div className="description">Wipes data and starts new session</div>
      </div>
    </div>;
};

require("./resets.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./resets.js");